var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7939 43.1055V50.002H43.1043C45.001 50.002 46.5526 48.4505 46.5526 46.5537V43.1055H13.7939Z",
    fill: "#B4B4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.793 0H6.89648C8.7932 0 10.3448 1.55156 10.3448 3.44828V46.5517C10.3448 48.4484 11.8963 50 13.793 50C15.6898 50 17.2413 48.4484 17.2413 46.5517V43.1034H42.2413V3.44828C42.2413 1.55156 40.6898 0 38.793 0Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7588 26.7246H39.6553V28.4488H32.7588V26.7246Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9316 26.7246H31.0351V28.4488H12.9316V26.7246Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 30.1719H39.6554V31.896H22.4141V30.1719Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9316 30.1719H20.6902V31.896H12.9316V30.1719Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4492 37.0703H39.6561V38.7945H28.4492V37.0703Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9316 37.0703H26.7247V38.7945H12.9316V37.0703Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2592 16.0336L25.8628 16.3783L26.4665 16.0336C29.3111 14.1368 31.0353 10.8611 31.0353 7.41287V5.1714L25.8628 3.44727L20.6904 5.1714V7.41287C20.6904 10.8611 22.4146 14.0505 25.2592 16.0336Z",
    fill: "#0967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5167 12.7603L24.5684 11.295C25.7752 10.433 26.6372 9.13987 26.7235 7.58789L28.4477 7.76047C28.2751 9.82936 27.1546 11.6398 25.5167 12.7603Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1035 33.623H39.6552V35.3472H18.1035V33.623Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9316 33.623H16.3799V35.3472H12.9316V33.623Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 23.2754H39.6554V24.9995H22.4141V23.2754Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9316 23.2754H20.6902V24.9995H12.9316V23.2754Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8271 18.9648H31.8961V20.689H19.8271V18.9648Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89554 0C8.79226 0 10.3438 1.55156 10.3438 3.44828V9.48276H3.44727V3.44828C3.44727 1.55156 4.99882 0 6.89554 0Z",
    fill: "#B4B4B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.7f07406854eeae8eb6eac36d63b1128a.svg";
export { ForwardRef as ReactComponent };